import {getTypeOfObject, typeOfBlob} from "./objectHelper";

export const getTextForBlob = async (blob:any):Promise<string|undefined>=>{

    if(getTypeOfObject(blob) === typeOfBlob){
        return await (blob as Blob).text();
    }
    return undefined;
}

